"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ROLES_TO_TEXT () {
        return ROLES_TO_TEXT;
    },
    get STATUS_TYPES () {
        return STATUS_TYPES;
    }
});
const ROLES_TO_TEXT = {
    admin: "Admin",
    manager: "Manager",
    creator: "Creator",
    member: "Member",
    view_only: "View only",
    guest: "Guest"
};
var STATUS_TYPES = /*#__PURE__*/ function(STATUS_TYPES) {
    STATUS_TYPES["INVITED"] = "Invited";
    STATUS_TYPES["ACTIVE"] = "Active";
    STATUS_TYPES["SUSPENDED"] = "Suspended";
    return STATUS_TYPES;
}({});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3V0aWxzL3VzZXJzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJvbGVOYW1lIH0gZnJvbSBcIi4uL2F1dGhvcml6YXRpb25cIjtcblxuZXhwb3J0IGNvbnN0IFJPTEVTX1RPX1RFWFQ6IFJlY29yZDxFeGNsdWRlPFJvbGVOYW1lLCBcInB1YmxpY1VzZXJcIj4sIHN0cmluZz4gPSB7XG4gIGFkbWluOiBcIkFkbWluXCIsXG4gIG1hbmFnZXI6IFwiTWFuYWdlclwiLFxuICBjcmVhdG9yOiBcIkNyZWF0b3JcIixcbiAgbWVtYmVyOiBcIk1lbWJlclwiLFxuICB2aWV3X29ubHk6IFwiVmlldyBvbmx5XCIsXG4gIGd1ZXN0OiBcIkd1ZXN0XCIsXG59IGFzIGNvbnN0O1xuXG5leHBvcnQgZW51bSBTVEFUVVNfVFlQRVMge1xuICBJTlZJVEVEID0gXCJJbnZpdGVkXCIsXG4gIEFDVElWRSA9IFwiQWN0aXZlXCIsXG4gIFNVU1BFTkRFRCA9IFwiU3VzcGVuZGVkXCIsXG59XG4iXSwibmFtZXMiOlsiUk9MRVNfVE9fVEVYVCIsIlNUQVRVU19UWVBFUyIsImFkbWluIiwibWFuYWdlciIsImNyZWF0b3IiLCJtZW1iZXIiLCJ2aWV3X29ubHkiLCJndWVzdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7UUFFYUE7ZUFBQUE7O1FBU0RDO2VBQUFBOzs7QUFUTCxNQUFNRCxnQkFBaUU7SUFDNUVFLE9BQU87SUFDUEMsU0FBUztJQUNUQyxTQUFTO0lBQ1RDLFFBQVE7SUFDUkMsV0FBVztJQUNYQyxPQUFPO0FBQ1Q7QUFFTyxJQUFBLEFBQUtOLHNDQUFBQTs7OztXQUFBQSJ9